import { createSelector } from 'reselect';
import { RootState } from '../store';
import { TestParameters } from './types';

const loading = (state: RootState) => state.waterTestStrip.loading;
const error = (state: RootState) => state.waterTestStrip.error;
const success = (state: RootState) => state.waterTestStrip.success;

const selectWaterTestStripResult = createSelector(
  [(state: RootState) => state.waterTestStrip.data],
  (data) => data?.parameters as TestParameters
);

const selectWaterTestStripStatus = (state: RootState) => state.waterTestStrip.status;

export const WaterTestStripSelector = {
  selectWaterTestStripStatus,
  selectWaterTestStripResult,
  loading,
  error,
  success,
};